var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcnChevronTop = function SvgIcnChevronTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.354 2.354 8.5 5.5a.707.707 0 0 0 1-1L5.707.707a1 1 0 0 0-1.414 0L.5 4.5a.707.707 0 0 0 1 1l3.146-3.146a.5.5 0 0 1 .708 0Z",
    fill: "#fff"
  })));
};

export { SvgIcnChevronTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjM1MzU1IDIuMzUzNTVMOC41IDUuNUM4Ljc3NjE0IDUuNzc2MTQgOS4yMjM4NiA1Ljc3NjE0IDkuNSA1LjVDOS43NzYxNCA1LjIyMzg2IDkuNzc2MTQgNC43NzYxNCA5LjUgNC41TDUuNzA3MTEgMC43MDcxMDdDNS4zMTY1OCAwLjMxNjU4MyA0LjY4MzQyIDAuMzE2NTgyIDQuMjkyODkgMC43MDcxMDdMMC41IDQuNUMwLjIyMzg1OCA0Ljc3NjE0IDAuMjIzODU4IDUuMjIzODYgMC41IDUuNUMwLjc3NjE0MiA1Ljc3NjE0IDEuMjIzODYgNS43NzYxNCAxLjUgNS41TDQuNjQ2NDUgMi4zNTM1NUM0Ljg0MTcxIDIuMTU4MjkgNS4xNTgyOSAyLjE1ODI5IDUuMzUzNTUgMi4zNTM1NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";